
import React, { useState, useRef, useEffect } from "react";
import "../../CreateBatch/dropdown-CB.css";
// import DropDownIcon from "../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
import DropDownIcon from "../../../Assets/Images/CreateBatch/icon-dropdown-menu.png";
export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  isUnique, // Add this line to receive the boolean prop
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);


  // FOR CATCH LABLE OF DROPDOWN
  useEffect(() => {
    const selectedOption = options.find((option) => option.id === selected);
    if (selectedOption) {
      setSelectedLabel(selectedOption.label);
    } else {
      setSelectedLabel(""); // Clear if no option matches the selected ID
    }
  }, [selected, options]);
  
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleClick = (option) => {
    setSelected(option.id); // Pass the ID of the selected option
    setIsActive(false);
    console.log("Selected option ID:", option.id); // Log the ID of the selected option
    setSelectedLabel(option.label);
  };

  return (
    <div className={`dropdown-CB ${className}`} style={{ width, ...style }} ref={dropdownRef}>
      <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
      </label>
      <div
        className={isUnique ? "dropdown-CB-btn-Red-Blink" : "dropdown-CB-btn"} // Switch class based on isUnique prop
        onClick={() => setIsActive(!isActive)}
        style={{ color: selectedLabel ? "black" : "grey" }} // Change color conditionally
      >
        {selectedLabel || "Select option"} {/* Display "Select option" when no label is selected */}
        <img src={DropDownIcon} alt="dropdown-icon" />
      </div>
      {isActive && (
        <div
          className="dropdown-content-CBV2"
          style={{ width: customWidth, top: customTop }}
        >
          {options.map((option) => (
            <div
              key={option.id}
              className="dropdown-item-CBV2"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
